import { useCallback, useMemo } from "react";

import { useField } from "formik";

import { GeoMap } from "components/elements";
import { getCountries } from "utils/continents";
import { getFieldTestId } from "utils/formik";

export type CountriesFieldProps = {
  name: string;
  dataTestId?: string;
};

export function CountriesField({ name, dataTestId }: CountriesFieldProps) {
  const [, { value }, { setTouched, setValue }] = useField<
    string[] | undefined
  >(name);

  const availableCountries = useMemo(getCountries, []);

  const handleSelect = useCallback(
    (changedCodes: string[], add: boolean) => {
      const codes = new Set(value);
      for (const code of changedCodes) {
        if (add) {
          codes.add(code);
        } else {
          codes.delete(code);
        }
      }
      setTouched(true);
      setValue([...codes.values()]);
    },
    [value, setTouched, setValue]
  );

  return (
    <GeoMap
      allCountries={availableCountries}
      markedCountries={value}
      dataTestId={dataTestId || getFieldTestId(name)}
      onItemsSelected={handleSelect}
    />
  );
}
